import { memo } from 'react';
import Box from '@mui/material/Box';

import type { CommonCase } from 'models';
import { commonCaseFields } from 'configs';
import { PageLoader, NoData, Error, FieldsList, TitledBox } from 'components';
import { CaseContainer } from 'shared/components/styled/Cases';
import CaseHeader from 'shared/components/CaseHeader';

import { Chat, EntityName } from 'features/chat';
import { FileLoader, EntityType } from 'features/file-loader';

import { useStyles } from './style';

interface Props {
  commonCase: CommonCase | null;
  loading: boolean;
  error: boolean;
}

const CommonCaseDetails = ({ commonCase, loading, error }: Props) => {
  const classes = useStyles();

  if (loading) return <PageLoader />;
  if (error) return <Error />;
  if (!commonCase) return <NoData />;

  return (
    <CaseContainer>
      <CaseHeader
        title="Palvelupyyntö"
        status={commonCase.Status}
        number={commonCase.Title}
      />
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }}>
        <Box
          display="flex"
          flexDirection="column"
          flex={1}
          marginRight={{ xs: 0, sm: '30px' }}
          marginBottom={{ xs: '30px', sm: 0 }}
        >
          <TitledBox
            title={'Information'}
            cls={{ boxWrapper: classes.boxWrapper }}
          >
            <FieldsList data={commonCase} list={commonCaseFields.otherInfo} />
          </TitledBox>
          <TitledBox
            title={'Documents'}
            cls={{ boxWrapper: classes.boxWrapper, box: classes.documentsBox }}
          >
            <FileLoader
              cached
              readonly
              entityId={commonCase.Id}
              entityType={EntityType.CommonCase}
            />
          </TitledBox>
        </Box>
        <Box display="flex" flexDirection="column" flex={1}>
          <TitledBox
            title={'Chat'}
            cls={{ boxWrapper: classes.boxWrapper, box: classes.zeroPadding }}
          >
            <Chat
              entityId={commonCase.Id}
              entityName={EntityName.Incident}
              readonly
              pollingInterval={10000}
            />
          </TitledBox>
          <TitledBox
            title={'#portal.incident.task.common.header'}
            cls={{ boxWrapper: classes.boxWrapper }}
          >
            <FieldsList data={commonCase} list={commonCaseFields.taskInfo} />
          </TitledBox>
        </Box>
      </Box>
    </CaseContainer>
  );
};

export default memo(CommonCaseDetails);
